__turbopack_context__.v({
  "searchDiv": "SearchPopup-module-scss-module__N0k6ha__searchDiv",
  "searchInput": "SearchPopup-module-scss-module__N0k6ha__searchInput",
});
